import React from "react";
import { getNumberFormatter } from "utilities/formatter";

interface Props {
  value: string
}

const ReadonlyNumber = ({ value }: Props) => {
  const formatter = getNumberFormatter();
  const formatted = formatter.format(Number.parseFloat(value));

  return <>{formatted}</>;
};

export default ReadonlyNumber;